import ContactPage from './ContactPage';

const ContactsConfig = {
  settings: {
    layout: {
      config: {
        navbar: {
          display: false,
        },
        toolbar: {
          display: false,
        },
        footer: {
          display: false,
        },
        leftSidePanel: {
          display: false,
        },
        rightSidePanel: {
          display: false,
        },
      },
    },
  },
  routes: [
    {
      path: 'contact/:id',
      element: <ContactPage />,
      auth: null,
    },
  ],
};

export default ContactsConfig;
